/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import config from 'cio/config/environment';
import AuthService from 'cio/services/auth';
export default class DebugWidget extends Component<never> {
  @service auth!: AuthService;

  get shouldBeDisplayed() {
    if (!this.auth.hasPermission('account/edit')) {
      return false;
    }

    return config.isStandalone || config.cioEnvironment === 'development' || config.cioEnvironment === 'devbox';
  }
}
